import { Button } from 'react-bootstrap';
import { FaPlus, FaUserFriends } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import SubHeading from '../../../../Components/SubHeading';

function DevelopmentPartners() {
  return (
    <div className="card content-section">
      <div className="card-header">
        <SubHeading id="development_partners" Icon={FaUserFriends}>
          <div>
            <Button>
              <FaPlus />
              <FormattedMessage id={'new_development_partner'} />
            </Button>
            <Button>
              <FaPlus />
              <FormattedMessage id={'new_development_partner_user'} />
            </Button>
          </div>
        </SubHeading>
      </div>
      <div className="card-body"></div>
    </div>
  );
}

export default DevelopmentPartners;
